import { render, staticRenderFns } from "./LongShortRatio.vue?vue&type=template&id=88366b8a&scoped=true&"
import script from "./LongShortRatio.vue?vue&type=script&lang=js&"
export * from "./LongShortRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88366b8a",
  null
  
)

export default component.exports